document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.home-banner-announcement-btn');
  const panel = document.querySelector('.home-banner-announcement-panel');
  const closeBtn = document.querySelector('.home-banner-close-btn');
  let isAnimating = false;
  let isOpen = false;

  if (panel) {
    panel.classList.remove('is-open', 'is-active', 'is-closing');
    panel.style.transform = 'translateX(-100%)';
    panel.style.opacity = '0';
    panel.style.transition = 'none';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        panel.style.transition = '';
        panel.style.transform = '';
        panel.style.opacity = '';
      });
    });
  }
  if (button) {
    button.classList.remove('is-active', 'is-animating-up', 'is-animating-down');
    button.setAttribute('aria-expanded', 'false');
  }

  function openSequence() {
    if (isAnimating || isOpen) return;

    isAnimating = true;

    button.classList.add('is-animating-up', 'is-active');
    button.setAttribute('aria-expanded', 'true');

    setTimeout(() => {
      panel.classList.add('is-open', 'is-active');
      isOpen = true;
      isAnimating = false;
    }, 400);
  }

  function closeSequence() {
    if (isAnimating || !isOpen) return;

    isAnimating = true;

    panel.classList.add('is-closing');
    panel.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');

    setTimeout(() => {
      button.classList.add('is-animating-down');
      button.classList.remove('is-active', 'is-animating-up');
      panel.classList.remove('is-active', 'is-closing');

      setTimeout(() => {
        button.classList.remove('is-animating-down');
        isOpen = false;
        isAnimating = false;
      }, 400);

    }, 400);
  }

  function toggle() {
    if (isOpen) {
      closeSequence();
    } else {
      openSequence();
    }
  }

  if (button) {
    button.addEventListener('click', toggle);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeSequence);
  }
});

const HOME_BANNER_SECTION_SELECTOR = '.home-banner';
const HOME_BANNER_DEFAULT_DURATION = 5;

const addHomeBannerDots = (emblaApi, dotsNode) => {
  let dotNodes = [];

  const buildDots = () => {
    dotsNode.innerHTML = emblaApi
      .scrollSnapList()
      .map(() => '<button class="embla__dot" type="button" aria-label="Slide"></button>')
      .join('');

    dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
    dotNodes.forEach((dotNode, index) => {
      dotNode.addEventListener('click', () => emblaApi.scrollTo(index));
    });
  };

  const toggleActiveDot = () => {
    dotNodes[emblaApi.previousScrollSnap()]?.classList.remove('embla__dot--selected');
    dotNodes[emblaApi.selectedScrollSnap()]?.classList.add('embla__dot--selected');
  };

  emblaApi
    .on('reInit', buildDots)
    .on('reInit', toggleActiveDot)
    .on('select', toggleActiveDot);

  buildDots();
  toggleActiveDot();
};

const homeBannerIsDesktopViewport = () => window.matchMedia('(min-width: 768px)').matches;

const homeBannerGetActiveVideo = (slideNode) => {
  const wrapperSelector = homeBannerIsDesktopViewport() ? '.desktop-only' : '.mobile-only';
  return slideNode.querySelector(`${wrapperSelector} video`);
};

const homeBannerPauseAllVideos = (slideNodes) => {
  slideNodes.forEach((slideNode) => {
    slideNode.querySelectorAll('video').forEach((video) => video.pause());
  });
};

const homeBannerAutoAdvance = (emblaApi, slideNodes) => {
  let advanceTimer = null;
  let activeVideo = null;

  const onVideoEnded = () => emblaApi.scrollNext();

  const clearAdvance = () => {
    clearTimeout(advanceTimer);
    activeVideo?.removeEventListener('ended', onVideoEnded);
    activeVideo = null;
  };

  const playCurrentSlide = () => {
    clearAdvance();
    homeBannerPauseAllVideos(slideNodes);

    const slideNode = slideNodes[emblaApi.selectedScrollSnap()];
    if (!slideNode) return;

    const video = homeBannerGetActiveVideo(slideNode);
    if (video) {
      activeVideo = video;
      video.currentTime = 0;
      video.play().catch(() => {});
      video.addEventListener('ended', onVideoEnded, { once: true });
      return;
    }

    const duration = parseFloat(slideNode.dataset.duration) || HOME_BANNER_DEFAULT_DURATION;
    advanceTimer = setTimeout(() => emblaApi.scrollNext(), duration * 1000);
  };

  emblaApi.on('select', playCurrentSlide);
  playCurrentSlide();
};

const initializeHomeBannerCarousel = (sectionNode) => {
  if (sectionNode.dataset.carouselInitialized === 'true') return;
  if (typeof EmblaCarousel === 'undefined') return;

  const emblaNode = sectionNode.querySelector('.home-banner-embla');
  const viewportNode = emblaNode?.querySelector('.embla__viewport');
  if (!emblaNode || !viewportNode) return;

  const slideNodes = Array.from(viewportNode.querySelectorAll('.home-banner-slide'));
  if (slideNodes.length === 0) return;

  const emblaApi = EmblaCarousel(viewportNode, {
    loop: true,
    watchDrag: slideNodes.length > 1,
  });
  sectionNode.dataset.carouselInitialized = 'true';

  if (slideNodes.length === 1) {
    slideNodes[0].querySelectorAll('video').forEach((video) => (video.loop = true));
    homeBannerGetActiveVideo(slideNodes[0])?.play().catch(() => {});
    return;
  }

  const dotsNode = sectionNode.querySelector('.home-banner-dots');
  if (dotsNode) {
    addHomeBannerDots(emblaApi, dotsNode);
  }

  homeBannerAutoAdvance(emblaApi, slideNodes);
};

const initializeHomeBannerCarousels = () => {
  document.querySelectorAll(HOME_BANNER_SECTION_SELECTOR).forEach((sectionNode) => {
    initializeHomeBannerCarousel(sectionNode);
  });
};

initializeHomeBannerCarousels();

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.matches(HOME_BANNER_SECTION_SELECTOR)) {
    initializeHomeBannerCarousel(event.target);
    return;
  }

  const nestedSection = event.target.querySelector(HOME_BANNER_SECTION_SELECTOR);
  if (nestedSection) {
    initializeHomeBannerCarousel(nestedSection);
  }
});